import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 90vh;
  width: 100%;
  background-color: #f3f4f8;
  padding: 2rem;
`;

export const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  width: 100%;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 4rem 3rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;

  img {
    max-width: 200px;
    height: auto;
  }
`;

export const Title = styled.h1`
  font-size: 2.4rem;
  font-family: 'Biotif', sans-serif;
  font-weight: 600;
  color: #222247;
  margin: 0 0 1.5rem 0;
  line-height: 1.4;
`;

export const Message = styled.p`
  font-size: 1.8rem;
  font-family: 'Biotif', sans-serif;
  color: #222247;
  margin: 0 0 2.5rem 0;
  line-height: 1.6;

  strong {
    color: #4948ac;
    font-weight: 600;
    font-size: 2rem;
  }
`;

export const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid #f3f4f8;
  border-top: 4px solid #4948ac;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin: 0 0 2.5rem 0;
`;

export const RedirectInfo = styled.p`
  font-size: 1.4rem;
  font-family: 'Biotif', sans-serif;
  color: #666;
  margin: 0;
  line-height: 1.5;

  a {
    color: #4948ac;
    text-decoration: none;
    font-weight: 600;
    transition: color 0.2s ease;

    &:hover {
      color: #2dcaff;
    }
  }
`;
